import map from "../async/map";
import mapSeries from "../async/mapSeries";
import reduce from "../async/reduce";
import filter from "../async/filter";
import filterSeries from "../async/filterSeries";
import reject from "../async/reject";
import rejectSeries from "../async/rejectSeries";
import * as R from "./ramda"; // export const pipeAsync = (...fns: ((x: any) => any)[]) => {
//   if (fns.length < 1) {
//     throw Error('pipe requires at least one argument')
//   }
//   fns.forEach((fn, i) => {
//     if (typeof fn !== 'function') {
//       throw Error(`pipe requires each argument
// to be a function. Argument #${i + 1} is of type "${typeof fn}"`)
//     }
//   })
//   // shift out the 1st function for multiple arguments
//   const start = fns.shift()
//   const chain = (q, fn) => q.then(fn)
//   return () => fns.reduce(chain, new Promise((res) => res(start(...args))))
// }

//| typeof filter
const promiseWrapper = async (operation, iterator, list) => {
  const result = await new Promise(res => operation(list, async value => {
    // callback
    const itemResult = await iterator(value);
    return itemResult; // return callback(null, itemResult)
  }, (_, asyncResult) => res(asyncResult)));
  return result;
};

const createOperator = (currentOperator, iterator) => async list => {
  const result = await promiseWrapper(currentOperator, async value => {
    const itemResult = await iterator(value);
    return itemResult;
  }, list);
  return result;
};

const createObjOperator = (currentOperator, iterator) => async object => {
  const keys = R.keys(object);
  const result = await promiseWrapper(currentOperator, async currentKey => {
    const itemResult = await iterator(object[currentKey], currentKey);
    return [currentKey, itemResult];
  }, keys);
  return R.fromPairs(result);
};

const createObjSelectionOperator = (currentOperator, iterator) => async object => {
  const keys = R.keys(object);
  const selectedPaths = await promiseWrapper(currentOperator, async currentKey => {
    const itemResult = await iterator(object[currentKey], currentKey);
    return itemResult;
  }, keys);
  return R.pick(selectedPaths)(object);
};

export const mapAsync = iterator => createOperator(map, iterator);
export const mapAsyncSeries = iterator => createOperator(mapSeries, iterator);
export const mapObjIndexedAsync = iterator => createObjOperator(map, iterator);
export const mapObjIndexedAsyncSeries = iterator => createObjOperator(mapSeries, iterator); /// PICK

export const filterAsync = iterator => createOperator(filter, iterator);
export const filterAsyncSeries = iterator => createOperator(filterSeries, iterator);
export const pickByAsync = iterator => createObjSelectionOperator(filter, iterator);
export const pickByAsyncSeries = iterator => createObjSelectionOperator(filterSeries, iterator); /// REJECT

export const rejectAsync = iterator => createOperator(reject, iterator);
export const rejectAsyncSeries = iterator => createOperator(rejectSeries, iterator);
export const omitByAsync = iterator => createObjSelectionOperator(reject, iterator);
export const omitByAsyncSeries = iterator => createObjSelectionOperator(rejectSeries, iterator);
export const reduceAsync = (iterator, initialAcc) => async list => {
  const result = await new Promise(res => reduce(list, initialAcc, async (acc, item, callback) => {
    const itemResult = await iterator(acc, item);
    return callback(null, itemResult);
  }, (_, asyncResult) => res(asyncResult)));
  return result;
}; // export const {
//   parallel,
//   series,
//   seq: pipeAsync,
// } = async